import { useTranslation } from 'react-i18next';
import { validateCPF } from 'validations-br';
import { z } from 'zod';

export function OnboardingAddResponsibleSchema() {
  const { t } = useTranslation('validation');

  const baseSchema = z.object({
    email: z.string().email(t('emailInvalid')),
    socialName: z.string().optional(),
    name: z.string().min(1, t('notEmpty')),
    documentNumber: z
      .string()
      .min(1, t('cpfRequired'))
      .refine(validateCPF, t('invalidCPF')),
    genre: z.string().min(1, t('notEmpty')),
    birthDate: z.string().min(1, t('notEmpty')),
    phone: z.string().min(1, t('notEmpty')),

    isTechnicalResponsible: z.boolean(),
  });

  const noTechnicalResponsibleSchema = z.object({
    isTechnicalResponsible: z.literal(true),
  });

  const technicalResponsibleSchema = z.object({
    isTechnicalResponsible: z.literal(false),
    technicalResponsibleEmail: z.string().email(t('emailInvalid')),
    technicalResponsibleSocialName: z.string().optional(),
    technicalResponsibleName: z.string().min(1, t('notEmpty')),
    technicalResponsibleDocumentNumber: z
      .string()
      .min(1, t('cpfRequired'))
      .refine(validateCPF, t('invalidCPF')),
    technicalResponsibleGenre: z.string(),
    technicalResponsibleBirthDate: z.string(),
    technicalResponsiblePhones: z.string(),
  });

  return z.discriminatedUnion('isTechnicalResponsible', [
    baseSchema.merge(noTechnicalResponsibleSchema),
    baseSchema.merge(technicalResponsibleSchema),
  ]);
}
export type IOnboardingAddResponsibleForm = z.infer<
  ReturnType<typeof OnboardingAddResponsibleSchema>
>;
